<template>
    <div>
        <div class="queryPanel">
            <div class="queryPanel_form" :class="{'queryPanel_form_show': showForm}">
                <Form 
                    :form="queryForm" 
                    @handleSelectChange="handleSelectChange"
                    @handlePressEnter="handlePressEnter"
                    @handleInputClear=handleInputClear
                    @handlePickerDateChange="handlePickerDateChange"
                ></Form>
            </div>
            <div class="queryPanel_btn">
                <a-dropdown-button size="small" @click="handle('search')">
                    <icon-search size="14" style="marginRight:5px;"/>
                    {{ $t('base.search') }}
                    <template #content>
                        <a-doption @click="handle('reset')">
                            <icon-refresh size="14" style="marginRight:5px;"/>
                            {{ $t('base.reset') }}
                        </a-doption>
                    </template>
                </a-dropdown-button>
                <span class="openBtn" v-if="!showForm" @click="showFormPanel(true)">
                    <icon-down-circle size="14"/>
                    {{ $t('base.open') }}
                </span>
                <span class="openBtn" v-else @click="showFormPanel(false)">
                    <icon-up-circle size="14" />
                    {{ $t('base.close') }}
                </span>
            </div>
        </div>

        <Table 
            class="tableList"
            ref="tableRef"
            :table="table"
            @changePage="changePage"
            @changePageSize="changePageSize"
        >
            <template v-slot:columns="{props}">
                    <div v-if="props.column.key == 'warning_status'">
                        <a-tag :color="props.record.warning_status_val == 10? 'green' : props.record.warning_status_val == 20? 'orange' : 'red'">{{ props.record.warning_status }}</a-tag>
                    </div>
                    <div v-if="props.column.key == 'order_channel_type'">
                        <a-tag :color="props.record.order_channel_type_val == 0? 'blue' : props.record.order_channel_type_val == 1? 'green' : props.record.order_channel_type_val == 2? 'pink' : 'orange'">{{ props.record.order_channel_type }}</a-tag>
                    </div>
                    <div v-if="props.column.key == 'detail'">
                        <div class="detail">{{ $t('order.sku') }}: {{ props.record.detail.SKU }}</div> 
                        <div class="detail">{{ $t('warning.qty') }}: {{ props.record.detail.quantity }}</div>
                    </div>
            </template>
            <template v-slot:tableOperate="{ props }"> 
                <a-button v-permission="'setting.warning.changeToError'" type="primary" status="danger" size="mini" :disabled="props.record.warning_status_val != 20" @click="handle('changeToError',props.record)">
                    {{ $t('warning.changeToError') }}
                </a-button>
            </template>
        </Table>

        <!-- 变更为ERROR -->
        <a-modal 
            v-model:visible="visible"
            width="40%"
            :render-to-body="false"
            @ok="onBeforeOk"
        >
            <template #title>{{ $t('warning.changeToError') }}</template>
            {{ $t('order.instruction')}}: 
            <a-input v-model="instruction" :style="{width:'620px'}" allow-clear />
        </a-modal>
    </div>  
</template>

<script setup>
    import { onMounted, reactive, ref, watch, nextTick, h } from 'vue';
    import { WarningApi } from '@/api/WarningApi.js';
    import { OrderApi } from '@/api/OrderApi.js'; 
    import { Message, Modal } from '@arco-design/web-vue';
    import Table from '@/components/Table.vue';
    import Form from '@/components/Form.vue';
    import { WarningListQuery } from './queryConfig/WarningListQuery.js';
    import { useI18n } from 'vue-i18n';
    import { useLocale } from '@/store/index.js';
    import { dateToTimestamp, timestampToDate, formatterToPoint, formatterToComma, getNowDate, getWeek } from '@/utils/index.js';

    const localeStore = useLocale()

    const { t } = useI18n()

    const visible = ref(false)
    const instruction = ref('')
    const rowData = ref(null)
    const showForm = ref(false)
    const queryForm = reactive(WarningListQuery)
    const table = ref({
        datas:[],
        columns:[
            {
                title: '#',
                dataIndex: 'No',
                key:'No',
                width:'60',
                fixed:'left',
                align:'left',
            },
            {
                // title: '订单名称',
                title: t('order.orderName'),
                dataIndex: 'order_name',
                key:'order_name',
                width:'150',
                ellipsis:true,
                tooltip:true,  
                align:'left',
            },
            {
                // title: '订单类型',
                title: t('order.orderChannelType'),
                dataIndex: 'order_channel_type',
                key:'order_channel_type',
                width:'120',
                ellipsis:true,
                tooltip:true,
                align:'left',
                slotName:'slot',
            },
            {
                // title: '出库单号',
                title: t('warning.deliveryNumber'),
                dataIndex: 'key2',
                key:'key2',
                width:'160',
                ellipsis:true,
                tooltip:true,
                align:'left',
            },
            {
                // title: '仓库',
                title: t('warning.wms'),
                dataIndex: 'key3',
                key:'key3',
                width:'120',
                ellipsis:true,
                tooltip:true,
                align:'left',
            },
            // {
            //     // title: '预警类型',
            //     title: t('warning.warningType'),
            //     dataIndex: 'warning_type',
            //     key:'warning_type',
            //     width:'130',
            //     ellipsis:true,
            //     tooltip:true,
            //     align:'left',
            // },
            {
                // title: '预警状态',
                title: t('warning.warningStatus'),
                dataIndex: 'warning_status',
                key:'warning_status',
                width:'150',
                ellipsis:true,
                tooltip:true,
                align:'left',
                slotName:'slot',
            },
            {
                // title: '预警日期',
                title: t('warning.warningTimestamp'),
                dataIndex: 'warning_timestamp',
                key:'warning_timestamp',
                width:'150',
                ellipsis:true,
                tooltip:true,
                align:'left',
            },
            {
                // title: '详情',
                title: t('warning.detail'),
                dataIndex: 'detail',
                key:'detail',
                width:'180',
                ellipsis:true,
                tooltip:true,
                align:'left',
                slotName:'slot',
            },
            {
                // title: '备注',
                title: t('order.instruction'),
                dataIndex: 'instruction',
                key:'instruction',
                width:'150',
                ellipsis:true,
                tooltip:true,
                align:'left',
            },
            {
                // title: '创建人',
                title: t('warning.updateUser'),
                dataIndex: 'update_user',
                key:'update_user',
                width:'130',
                ellipsis:true,
                tooltip:true,
                align:'left',
            },
            {
                title: t('base.operate'),
                dataIndex: 'Optional',
                key:'Optional',
                slotName:'optional',
                width:'160',
                align:'center',
                fixed:'right'
            }
        ],
        configs:{
            scroll:{
                x:1000,
                y:560,
            },
            stripe:true,
            bordered:false,
            size:'large',
            loading:false,
            expandable:'',
            expand:false,
            pagination:{
                size:'mini',
                current:1,
                pageSize:10,
                total:0,
                pageSizeOptions:[10, 20, 50, 100],
                showJumper:true,
                showPageSize:true,
                showTotal:true,
            },
        },
    })
    const begin_date = ref('')
    const end_date = ref('')

    const handle = (type, row)=>{
        switch(type){
            case 'search':
                table.value.configs.pagination.current = 1
                getWarningList()
                break;
            case 'reset':
                queryForm.formField.forEach(i=>{
                    queryForm.formData[i.key] = ''
                })
                begin_date.value = ''
                end_date.value = ''
                table.value.configs.pagination.current = 1
                getWarningList()
                break;
            case 'changeToError':
                visible.value = true
                rowData.value = row
                instruction.value = ''
                break;
        }
    }

    const changePage = (current)=>{
        table.value.configs.pagination.current = current
        getWarningList()
    }

    const changePageSize = (pageSize)=>{
        table.value.configs.pagination.current = 1
        table.value.configs.pagination.pageSize = pageSize
        getWarningList()
    }

    // 列表查询-input
    const handleSelectChange = (val,item)=>{
        table.value.configs.pagination.current = 1
        getWarningList()
    }
    
    // 列表查询-input
    const handleInputClear = (val,item)=>{
        table.value.configs.pagination.current = 1
        getWarningList()
    }

    const handlePressEnter = (val,item)=>{
        table.value.configs.pagination.current = 1
        getWarningList()
    }

    const handlePickerDateChange = (val, item)=>{
        // console.log(val, item, 'val, item')
        if(!!val){
            begin_date.value = dateToTimestamp(`${ val[0]} 00:00:00`) 
            end_date.value = dateToTimestamp(`${ val[1]} 23:59:59`) 
        }else{
            begin_date.value = ''
            end_date.value = ''
        }
        getWarningList()
    }

    // 展开搜索栏
    const showFormPanel = (val)=>{
        showForm.value = val
    }

    // 获取预警列表
    const getWarningList = async()=>{
        let form = {}
        queryForm.formField.forEach(i=>{
            if(i.key != 'warning_timestamp'){
                form[i.key] = queryForm.formData[i.key]
            }
        })

        let param = {
            ...form,
            begin_date: begin_date.value,
            end_date: end_date.value,
        }
        let page_num = table.value.configs.pagination.current
        let page_size = table.value.configs.pagination.pageSize
        table.value.configs.loading = true

        let res = await WarningApi.getInstance().getWarningList(param, page_num, page_size)
        if(res.code == 0){
            res.data.records.length > 0 &&  res.data.records.forEach((i,index)=>{
                i.No = index + 1
                i.create_date = i.create_date.split(' ')[0]
                i.warning_timestamp = timestampToDate(i.warning_timestamp * 1000).split(' ')[0]
                i.warning_status_val = i.warning_status
                i.warning_status = i.warning_status == undefined? '-' : i.warning_status == 10? t('base.ok') : i.warning_status == 20? t('warning.warning') : t('warning.error')
                i.order_channel_type_val = i.order_channel_type
                i.order_channel_type = i.order_channel_type == undefined? '-' : i.order_channel_type == 0? t('order.user') : i.order_channel_type == 1? t('order.dealer') : i.order_channel_type == 2? t('order.ECommerceVendor') : t('order.notForSale')
                i.detail = i.detail == undefined? '-' : JSON.parse(i.detail)
                i.update_user = i.update_user == undefined? '-' : i.update_user
                i.instruction = i.instruction == undefined? '-' : i.instruction
            })
            table.value.datas = res.data.records
            table.value.configs.pagination.total = res.data.total
            table.value.configs.loading = false
        }else{  
            Message.error(res.msg)
        }
    }

    // 变更状态
    const onBeforeOk = async()=>{
        if(!instruction.value){
            Message.error(t('order.instruction')+ ' ' +t('base.noEmpty'))
            return false
        }

        console.log(rowData.value,'rowData.value')
        let param = {
            instruction: instruction.value, 
        }
        let res = await WarningApi.getInstance().changeToError(param, rowData.value.id)
        if(res.code == 0){
            Message.success(t('base.operateSuccess'))
            table.value.configs.pagination.current = 1
            getWarningList()
            return true
        }else{
            Message.error(res.msg)
            return false
        }
    }

    // 获取仓库
    const getWarehouse = async ()=>{
        let res = await WarningApi.getInstance().getWarehouse()
        if(res.code == 0){
            let item = queryForm.formField.find(i=> i.key == 'key3')

            res.data.length > 0 && res.data.forEach(i=>{
                item.options.push({
                    label: `${i.subinventory_name} | ${i.description}`,
                    value: i.subinventory_name,
                })
            })
        }else{
            Message.error(res.msg)
        }
    }


    onMounted(()=>{
        getWarningList()
        getWarehouse()
    })
</script>

<style lang="less" scoped>
.queryPanel{
    display: flex;
    // margin-bottom:7px;
    padding:7px;
    background: #fff;
    border-bottom: 1px dashed #ccc;

    .queryPanel_form{
        display: flex;
        flex:14;
        flex-direction: column;
        height: 33px;
        overflow: hidden;

        /deep/ .arco-form-layout-inline .arco-form-item{
            margin-bottom:0;
        }
    }

    .queryPanel_form_show{
        height: auto;
        overflow: visible;
    }

    .queryPanel_btn{
        display: flex;
        flex:1;
        justify-content: center;
        align-items: center;
        border-left:1px solid #eee;
        padding-left:5px;

        .openBtn{
            display: inline-block;
            padding: 3px 10px;
            margin: 2px 5px 0 5px;
            width: 80px;
            text-align: center;
            color: #165dff;
            cursor: pointer;
            border: 1px solid #165dff;
            border-radius:2px;
        }
    }

    /deep/ .arco-form-item-label-col > .arco-form-item-label{
        font-size:12px;
    }

    /deep/ .arco-form-item-layout-inline{
        margin-right: 0;
    }

    .form_btn{
        margin:5px 5px 3px;
        width:70px;
    }
}

/deep/ .operayeBox {
    margin-bottom: 7px;
    background: #fff;
    padding: 5px 24px 5px;
}

/deep/ .arco-btn-group{
    vertical-align: bottom;
}
/deep/ .arco-btn-group .arco-btn:first-child,
/deep/ .arco-btn-group .arco-btn:last-child{
    background: #165dff;
    color: #fff;
}

// 表格
/deep/ .arco-table-td{
    padding: 5px 0;
    border-right: 1px solid #eee;
}

.tableList{
    /deep/ .arco-table-th{
        background: #fff;
        border-bottom: 1px solid #eee;
        border-right: 1px solid #eee;
        font-size: 13px;
        font-weight: 600;
    }
}

/deep/ .arco-table-container{
    padding-bottom:0;
}

/deep/ .arco-picker-size-medium input,
/deep/ .arco-input-wrapper .arco-input.arco-input-size-medium,
/deep/ .arco-select-view-single.arco-select-view-size-medium .arco-select-view-input{
    font-size:12px;
}

/deep/ .arco-pagination-options .arco-select,
/deep/ .arco-pagination-jumper .arco-pagination-jumper-input input{
    background: #e7e7e7;
}

.detail{
    color:#666;
    font-size: 12px;
}
</style>